import type { AppKind } from "../site";
import { STORE_URLS } from "../site";
import type { UiCopy } from "../content/translations";

interface StoreButtonsProps {
  app: AppKind;
  copy: UiCopy;
}

function GooglePlayIcon() {
  return (
    <svg viewBox="0 0 28 32" aria-hidden="true">
      <path d="M2.1 1.4 17.6 16 2.2 30.7c-.5-.7-.8-1.6-.8-2.7V4c0-1 .2-1.9.7-2.6Z" fill="#34a853" />
      <path d="m18.8 17.2 3.9 3.7L5.8 30.5l13-13.3Z" fill="#fbbc04" />
      <path d="M22.8 11.2c1.5.8 2.5 1.6 2.5 2.8 0 1.1-.9 2-2.5 2.9l-3.3 1.8-4-3.8 3.9-4 3.4.3Z" fill="#ea4335" />
      <path d="m5.7 1.5 16.9 9.6-4.1 3.8L5.7 1.5Z" fill="#4285f4" />
    </svg>
  );
}

function AppStoreIcon() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M10.2 24.7H5.6a2 2 0 1 1 0-4h6.9l2.3-4H7.9a2 2 0 1 1 0-4h4.6l2-3.5-1.3-2.3a2 2 0 0 1 3.5-2l.2.4.2-.4a2 2 0 0 1 3.5 2l-8.7 15a2 2 0 0 1-1.7 2.8Zm16.2 0h-4.2l-2.3-4h4.2l-6.8-11.8 2.3-4 8.6 14.9a3.3 3.3 0 0 1-1.8 4.9Z"
        fill="currentColor"
      />
    </svg>
  );
}

interface StoreButtonProps {
  href: string;
  label: string;
  comingSoon: string;
  downloadOn: string;
  icon: React.ReactNode;
}

function StoreButton({ href, label, comingSoon, downloadOn, icon }: StoreButtonProps) {
  const content = (
    <>
      <span className="store-button__icon">{icon}</span>
      <span className="store-button__copy">
        <small>{href === "TODO" ? comingSoon : downloadOn}</small>
        <strong>{label}</strong>
      </span>
    </>
  );

  if (href === "TODO") {
    return (
      <span className="store-button store-button--disabled" aria-label={`${label}: ${comingSoon}`}>
        {content}
      </span>
    );
  }

  return (
    <a className="store-button" href={href} rel="noreferrer" target="_blank">
      {content}
    </a>
  );
}

export function StoreButtons({ app, copy }: StoreButtonsProps) {
  const urls = STORE_URLS[app];

  return (
    <div className="store-buttons" aria-label={copy.storeLinksLabel}>
      <StoreButton
        href={urls.googlePlay}
        label={copy.googlePlay}
        comingSoon={copy.comingSoon}
        downloadOn={copy.downloadOn}
        icon={<GooglePlayIcon />}
      />
      <StoreButton
        href={urls.appStore}
        label={copy.appStore}
        comingSoon={copy.comingSoon}
        downloadOn={copy.downloadOn}
        icon={<AppStoreIcon />}
      />
    </div>
  );
}
